import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { AppShell } from '@/shared/ui/app-shell'
import { PageHeader, PageHeaderSpacer } from '@/shared/ui/page-header'
import { useBackButton } from '@/shared/lib/telegram'

export const Route = createFileRoute('/offer')({
  component: OfferPage,
})

/**
 * Страница публичной оферты
 * 
 * Юридическая страница с договором публичной оферты.
 */
function OfferPage() {
  const navigate = useNavigate()

  // Нативная кнопка "Назад" → профиль
  useBackButton(true, () => navigate({ to: '/profile' }))

  return (
    <AppShell showBottomNav={false}>
      <PageHeader 
        title="Публичная оферта"
        hideBackButton
      />

      <PageHeaderSpacer />

      <main className="content-container pb-6">
        <div className="prose prose-sm dark:prose-invert max-w-none animate-in fade-in duration-300">
          <p className="text-gray-600 dark:text-gray-400 leading-relaxed">
            Настоящая оферта является официальным предложением Интернет-магазина «Дракон и Сорока», расположенного по адресу drakonisoroka.ru, заключить Договор купли-продажи товаров дистанционным способом.
          </p>

          <Section title="1. Определения">
            <p>
              <strong>1.1.</strong> Покупатель — физическое или юридическое лицо, размещающее Заказы на сайте drakonisoroka.ru, либо указанное в качестве получателя Товара.
            </p>
            <p>
              <strong>1.2.</strong> Продавец — Интернет-магазин «Дракон и Сорока».
            </p>
            <p>
              <strong>1.3.</strong> Интернет-магазин — сайт, расположенный по адресу drakonisoroka.ru, где представлены Товары, предлагаемые Продавцом для приобретения.
            </p>
            <p>
              <strong>1.4.</strong> Товар — чай, чайная посуда, аксессуары и иные товары, представленные к продаже на Сайте Продавца.
            </p>
            <p>
              <strong>1.5.</strong> Заказ — должным образом оформленный запрос Покупателя на приобретение и доставку перечня Товаров.
            </p>
          </Section>

          <Section title="2. Предмет договора">
            <p>
              <strong>2.1.</strong> Продавец обязуется передать в собственность Покупателя Товар, а Покупатель обязуется оплатить и принять Товар на условиях настоящей Оферты.
            </p>
            <p>
              <strong>2.2.</strong> Право собственности на Заказанные Товары переходит к Покупателю с момента фактической передачи Товара и оплаты полной стоимости.
            </p>
          </Section>

          <Section title="3. Порядок оформления заказа">
            <p>
              <strong>3.1.</strong> Заказ Товара осуществляется Покупателем через сервис сайта Интернет-магазина drakonisoroka.ru.
            </p>
            <p>
              <strong>3.2.</strong> При оформлении заказа Покупатель обязуется предоставить:
            </p>
            <ul className="list-disc list-inside space-y-1 text-gray-600 dark:text-gray-400">
              <li>фамилия, имя, отчество получателя;</li>
              <li>адрес доставки (если доставка до адреса);</li>
              <li>адрес электронной почты;</li>
              <li>контактный телефон.</li>
            </ul>
            <p>
              <strong>3.3.</strong> Продавец вправе запросить дополнительную информацию при необходимости.
            </p>
          </Section>

          <Section title="4. Доставка заказа">
            <p>
              <strong>4.1.</strong> Способы доставки указаны на Сайте при оформлении заказа.
            </p>
            <p>
              <strong>4.2.</strong> Стоимость доставки рассчитывается индивидуально, исходя из веса Товара, региона и способа доставки.
            </p>
            <p>
              <strong>4.3.</strong> Заказ вручается Покупателю либо лицу, указанному в Заказе в качестве получателя.
            </p>
          </Section>

          <Section title="5. Оплата товара">
            <p>
              <strong>5.1.</strong> Цена товара указывается на Сайте. В случае неверного указания цены, Продавец информирует Покупателя для подтверждения по исправленной цене.
            </p>
            <p>
              <strong>5.2.</strong> Цена на заказанный Товар изменению не подлежит.
            </p>
            <p>
              <strong>5.3.</strong> Оплата осуществляется способами, указанными на Сайте.
            </p>
          </Section>

          <Section title="6. Возврат товара">
            <p>
              <strong>6.1.</strong> Продовольственные товары (чай) надлежащего качества возврату и обмену не подлежат.
            </p>
            <p>
              <strong>6.2.</strong> Покупатель вправе отказаться от непродовольственного товара (посуда, аксессуары) в любое время до его передачи, а после передачи — в течение 7 дней.
            </p>
            <p>
              <strong>6.3.</strong> Возврат возможен при сохранении товарного вида и документа, подтверждающего покупку.
            </p>
            <p>
              <strong>6.4.</strong> При отказе от Товара Продавец возвращает денежную сумму (за исключением расходов на доставку) не позднее чем через 10 дней.
            </p>
          </Section>
        </div>
      </main>
    </AppShell>
  )
}

function Section({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <div className="mt-6">
      <h3 className="text-base font-semibold text-ink dark:text-white mb-3">
        {title}
      </h3>
      <div className="text-gray-600 dark:text-gray-400 leading-relaxed space-y-2">
        {children}
      </div>
    </div>
  )
}


























